import { GOFO_ORIGIN_HUBS } from "@redotech/redo-fulfillment-carrier-common/gofo-hubs";
import { GofoOriginHub } from "@redotech/redo-fulfillment-rate-common/create-carrier-account";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { RedoListItem } from "../../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";

export const GofoCarrierInput = groupInput({
  apiKey: input<string>({ validator: nonEmptyValidator }),
  userId: input<string>({ validator: nonEmptyValidator }),
  originHub: input<GofoOriginHub>({ validator: nonEmptyValidator }),
});

export type GofoCarrierValue = InputSchema.Value<typeof GofoCarrierInput>;

export type GofoCarrierForm = InputSchema.Input<typeof GofoCarrierInput>;

export const gofoCarrierDefault = (): GofoCarrierValue => ({
  apiKey: "",
  userId: "",
  originHub: "WE",
});

const originHubOptions: RedoListItem<GofoOriginHub>[] = GOFO_ORIGIN_HUBS.map(
  (hub) => ({
    id: hub.code,
    type: "text",
    text: `${hub.code} - ${hub.label}`,
    value: hub.code,
  }),
);

export const CreateGofoCarrierForm = memo(function CreateGofoCarrierForm({
  carrierInput,
}: {
  carrierInput: GofoCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        inputTypeHint="password"
        label="API key"
        placeholder=""
        setValue={carrierInput.inputs.apiKey.setValue}
        value={carrierInput.inputs.apiKey.value}
      />
      <RedoTextInput
        label="User ID"
        placeholder=""
        setValue={carrierInput.inputs.userId.setValue}
        value={carrierInput.inputs.userId.value}
      />
      <RedoSingleSelectDropdownInput
        label="Origin hub"
        options={originHubOptions}
        optionSelected={({ item }: { item: RedoListItem<GofoOriginHub> }) => {
          carrierInput.inputs.originHub.setValue(item.value);
        }}
        selectedItem={originHubOptions.find(
          (option) => option.value === carrierInput.inputs.originHub.value,
        )}
      />
    </>
  );
});
